import { useCallback } from 'react';
import { LoadingButton } from '@mui/lab';
import { Button, Stack } from '@mui/material';
import CustomTooltip from '../../../common/components/CustomTooltip';
import { MdSave as SaveOutlinedIcon } from 'react-icons/md';
import { MdSave as SaveAsIcon } from 'react-icons/md';
import { useSnapshot } from 'valtio';
import PoliciesProfileUIStateStore from '../../store/policies-profile-ui';
import {
  setSavePoliciesInProgress,
  setShowSaveAsModal,
} from '../../actions/policies-selection-ui-actions/policies-selection-ui-actions';
import updateProfileByIdAction from '../../actions/profiles-actions/save-profile-action';

const ButtonGroup: React.FC<React.PropsWithChildren> = () => {
  const { savePoliciesInProgress, disableSavePoliciesButton } = useSnapshot(
    PoliciesProfileUIStateStore,
  );

  const showSaveAsModal = useCallback(() => setShowSaveAsModal(true), []);

  return (
    <Stack
      alignItems='center'
      justifyContent='flex-end'
      minWidth={200}
      direction='row'
      gap={1}>
      <CustomTooltip title='Save current settings in a new profile.'>
        <span>
          <Button
            size='small'
            variant='outlined'
            color='primary'
            onClick={showSaveAsModal}
            startIcon={<SaveAsIcon fontSize='small' />}>
            Save As
          </Button>
        </span>
      </CustomTooltip>
      <CustomTooltip title='Save changes for current profile.'>
        <span>
          <LoadingButton
            loading={savePoliciesInProgress}
            loadingPosition='center'
            size='small'
            variant='outlined'
            color='primary'
            onClick={useCallback(() => {
              setSavePoliciesInProgress(true);
              setTimeout(() => {
                updateProfileByIdAction();
              }, 500);
            }, [])}
            disabled={disableSavePoliciesButton}
            startIcon={<SaveOutlinedIcon fontSize='small' />}>
            Save
          </LoadingButton>
        </span>
      </CustomTooltip>
    </Stack>
  );
};

export default ButtonGroup;
